"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GaugeDisplay = _interopRequireDefault(require("../GaugeDisplay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Container = _styledComponents["default"].figure.withConfig({
  displayName: "GaugeChart__Container",
  componentId: "yxxis6-0"
})(["margin:0;position:relative;width:", "px;height:", "px;"], function (_ref) {
  var size = _ref.size;
  return size === 'large' ? 496 : size === 'small' ? 378 : 226;
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'large' ? 488 : size === 'small' ? 354 : 226;
});

var ChartContainer = _styledComponents["default"].div.withConfig({
  displayName: "GaugeChart__ChartContainer",
  componentId: "yxxis6-1"
})(["position:absolute;bottom:0;width:", "px;height:", "px;", ""], function (_ref3) {
  var size = _ref3.size;
  return size === 'large' ? 396 : size === 'small' ? 262 : 172;
}, function (_ref4) {
  var size = _ref4.size;
  return size === 'large' ? 396 : size === 'small' ? 262 : 172;
}, function (_ref5) {
  var align = _ref5.align;
  return align === 'right' && (0, _styledComponents.css)(["right:0;"]);
});

var Title = _styledComponents["default"].figcaption.withConfig({
  displayName: "GaugeChart__Title",
  componentId: "yxxis6-2"
})(["margin:1rem;font-size:", "rem;color:", ";font-weight:", ";"], function (_ref6) {
  var size = _ref6.size,
      theme = _ref6.theme;
  return size === 'tiny' ? 1 : theme.font.size.h5;
}, function (props) {
  return props.theme.color.text;
}, function (props) {
  return props.theme.font.weight.black;
});

var Value = _styledComponents["default"].span.withConfig({
  displayName: "GaugeChart__Value",
  componentId: "yxxis6-3"
})(["font-size:", "rem;color:", ";font-weight:", ";position:absolute;top:20%;right:", ";"], function (_ref7) {
  var size = _ref7.size,
      theme = _ref7.theme;
  return size === 'large' ? theme.font.size.jumbo : size === 'small' ? theme.font.size.mega : theme.font.size.h3;
}, function (props) {
  return props.theme.color.text;
}, function (props) {
  return props.theme.font.weight.black;
}, function (_ref8) {
  var align = _ref8.align;
  return align === 'right' ? '60%' : '5%';
});

var A11yMessage = _styledComponents["default"].span.withConfig({
  displayName: "GaugeChart__A11yMessage",
  componentId: "yxxis6-4"
})(["position:absolute;left:-9999px;width:0;height:0;"]);
/**
 *
 * #### Gauge Chart made with Nivo library

This is the GaugeChart component and is used to display a value in a max.

 */


function GaugeChart(_ref9) {
  var _ref9$max = _ref9.max,
      max = _ref9$max === void 0 ? 10 : _ref9$max,
      _ref9$value = _ref9.value,
      value = _ref9$value === void 0 ? 0 : _ref9$value,
      _ref9$pattern = _ref9.pattern,
      pattern = _ref9$pattern === void 0 ? 'lavender' : _ref9$pattern,
      _ref9$align = _ref9.align,
      align = _ref9$align === void 0 ? 'left' : _ref9$align,
      _ref9$title = _ref9.title,
      title = _ref9$title === void 0 ? '' : _ref9$title,
      _ref9$className = _ref9.className,
      className = _ref9$className === void 0 ? '' : _ref9$className;
  var containerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)('tiny'),
      _useState2 = _slicedToArray(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  (0, _react.useEffect)(function () {
    var parentWidth = containerRef.current.parentNode.clientWidth;
    setSize(parentWidth > 496 ? 'large' : parentWidth > 378 ? 'small' : 'tiny');
  });
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    size: size,
    ref: containerRef
  }, /*#__PURE__*/_react["default"].createElement(Title, {
    size: size
  }, title), /*#__PURE__*/_react["default"].createElement(A11yMessage, null, Math.floor(value * 10) / 10, " out of ", max), /*#__PURE__*/_react["default"].createElement(Value, {
    "aria-hidden": "true",
    align: align,
    size: size
  }, Math.floor(value * 10) / 10), /*#__PURE__*/_react["default"].createElement(ChartContainer, {
    align: align,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_GaugeDisplay["default"], {
    max: max,
    value: value,
    pattern: pattern,
    align: align
  })));
}

var _default = GaugeChart;
exports["default"] = _default;